import { useState, useRef, useEffect } from 'react';
import { selectedItemsToProductsParser, ratingRequestParser } from 'shared/parsers';
import { purchaseTypes } from 'shared/constants/purchaseTypes';
import { postOrderMany } from 'services/orders';
import { orderTypes } from 'shared/constants/orderTypes';

type UseInstrumentsRatingRequestProps = {
  onRequested: () => void;
};

export const useInstrumentsRatingRequest = ({ onRequested }: UseInstrumentsRatingRequestProps) => {
  const [requestLoading, setRequestLoading] = useState(false);
  const didUnmount = useRef(false);

  useEffect(() => {
    return () => {
      didUnmount.current = true;
    };
  }, []);

  const requestRating = (items: any) => {
    setRequestLoading(true);

    const selectedItems = Object.values(items);
    const filteredRatingRequest = ratingRequestParser(selectedItems);

    const products = selectedItemsToProductsParser({
      selected: filteredRatingRequest,
      artifactType: orderTypes.INSTRUMENT,
      frequency: 0,
      purchaseType: purchaseTypes.ONE_TIME,
    });

    postOrderMany({ products })
      .then(() => {
        if (!didUnmount.current) {
          if (onRequested) {
            onRequested();
          }
        }
      })
      .finally(() => {
        if (!didUnmount.current) {
          setRequestLoading(false);
        }
      });
  };

  return {
    requestLoading,
    requestRating,
  };
};
